import { Box } from '@mui/material';

import { varFade } from '..';
import { m } from '../framer-motion-rsc';

import type { BoxProps } from '@mui/material';
import type { MotionProps } from 'framer-motion';
import type { FC } from 'react';

type Props = BoxProps & MotionProps;

interface TextAnimateProps extends Props {
  text: string;
}

export const TextAnimate: FC<TextAnimateProps> = ({
  text,
  variants,
  sx,
  ...props
}) => (
  <Box
    component={m.h1}
    sx={{
      typography: 'h1',
      overflow: 'hidden',
      display: 'inline-flex',
      ...sx,
    }}
    {...props}
  >
    {text.split( '' ).map((letter, index) => (
      <m.span key={index} variants={variants || varFade().inUp}>
        {letter}
      </m.span>
    ))}
  </Box>
);
